import LineMobileAndroidIcon from 'LuxKit/Icons/line/LineMobileAndroidIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import React from 'react'
import { useIntl } from 'react-intl'

function BedbankMobileOnlyPriceLabel() {
  const intl = useIntl()
  return <PromotionLabel variant="premium" icon={<LineMobileAndroidIcon />}>
    {intl.formatMessage({
      id: 'YZq93o6odc',
      defaultMessage: 'Mobile only price',
      description: 'Label for mobile-only price',
    })}
  </PromotionLabel>
}

export default BedbankMobileOnlyPriceLabel
